import axios from '../../../axios';
import ICareerBuilderJobPostingDTO from '../types/ICareerBuilderJobPostingDTO';

const url = '/jobsearch/api/career-builder';

export const postToCareerBuilder = (careerBuilderPostingDTO: ICareerBuilderJobPostingDTO) =>
  axios.post(`${url}`, careerBuilderPostingDTO);

export const deleteJobFromCareerBuilder = (jobId: string) => axios.delete(`${url}/${jobId}`);
